export default "__VITE_ASSET__CFbUnix___"